import React, { useState, useEffect, useCallback, useRef } from 'react';
import MasterButton, { ButtonLayoutType, ButtonSize, ButtonVariation } from "../../../components/button/MasterButton";
import RightArrow from "../../../assets/RightArrow.svg"

import { convertTimeString } from "../../../utils/TimeUtils"

import  Close from "../../../assets/CloseButton.svg";
import  EditButton from "../../../assets/EditButton.svg";

import "./dashboardParticipantDetailsModal.css";

import TabmenuBasic from "../../../components/tabmenubasic/tabmenubasic"

import ButtonGroup from "../../../components/buttonGroup/buttonGroup";

import axios from 'axios';

import Plotly from 'plotly.js-basic-dist';
import Plot from 'react-plotly.js';
import PlotlyEvent from "react-plotly.js"
import PlotlyData from "react-plotly.js";

import CustomTimeSelectionButtonBar from "../../../components/customTimeSelectionButtonBar/customTimeSelectionButtonBar";

import { DateRange } from "react-day-picker";

import moment from "moment-timezone";

import { useSharedState } from '../../../context/sharedState';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const VERSION = process.env.REACT_APP_API_VERSION;

type Trace = PlotlyData;

type DashboardParticipantDetailsModalProps = {
    onCloseClicked: () => void;
    participantName: string;
    organizationName: string;
    studyName: string;
    participantEUID: string;
    customTimeRange?: DateRange;
};

const formatDateRange = (date: Date | undefined): string => {

  if (!date) {
    return '';
  }

  return new Intl.DateTimeFormat('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
  }).format(date);
};

const getUTCOffset = (timezone: string | undefined): string => {
  
  if (!timezone || timezone === 'UTC') {
    return 'UTC';
  }

  const offsetMinutes = moment.tz(timezone).utcOffset(); // Get offset in minutes
  const sign = offsetMinutes >= 0 ? '+' : '-'; // Determine the sign
  const hours = Math.floor(Math.abs(offsetMinutes) / 60).toString().padStart(2, '0'); // Extract hours
  const minutes = (Math.abs(offsetMinutes) % 60).toString().padStart(2, '0'); // Extract minutes
  return `UTC${sign}${hours}:${minutes}`;
};

const DashboardParticipantDetailsModal: React.FC<DashboardParticipantDetailsModalProps> = ({ onCloseClicked, participantName, participantEUID, organizationName, studyName, customTimeRange }) => {
    
    // TODO: The Custom TimeRange selector is not implemented - need to implement it later

    const modalRef = useRef<HTMLDivElement | null>(null);

    const { isMobile } = useSharedState();

    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const [isLoading, setLoading] = useState(true);
    const [noData, setNoData] = useState(false);
    const [currentTimeline, setCurrentTimeline] = useState<string>(isMobile ? '1 Week' : '1 Week');
    const [plotWidth, setPlotWidth] = useState(0);

    // if(isMobile){
    //   setCurrentTimeline('Today');
    // }

    useEffect(() => {
      const updateWidth = () => {
        if (modalRef.current) {
          let offset = 40
          if(isMobile){
            offset = 0
          }
          setPlotWidth(modalRef.current.clientWidth - offset); // Subtract padding/margin if necessary
        }
      };
  
      // Update width when modal opens
      updateWidth();
  
      // Attach event listener
      window.addEventListener("resize", updateWidth);
  
      // Cleanup on unmount
      return () => {
        window.removeEventListener("resize", updateWidth);
      };
    }, []); // Re-run when modal state changes

    const [hotcoldGraph, sethotcoldGraph] = useState<any>(null);
    const [tempmovGraph, settempmovGraph] = useState<any>(null);
    const [intriangleGraph, setIntriangleGraph] = useState<any>(null);

    const [selectedDateRange, setSelectedDateRange] = useState<DateRange | undefined>({
      from: undefined,
      to: undefined,
    });

    const [selectedTimezoneString, setSelectedTimezoneString] = useState<string>("");
    
    // Set default timezone to the browser's timezone
    useEffect(() => {
        const browserTimezone = moment.tz.guess(); // Get the browser's timezone
        setSelectedTimezoneString(browserTimezone);
    }, []);

    useEffect(() => {

      if(participantName && participantEUID && selectedDateRange?.from != undefined && selectedDateRange?.to != undefined){

        console.log("Getting Participant Specific Data")

        console.log("Selected Participant name in Modal: ", participantName);
        console.log("Selected Participant EUID in Modal: ", participantEUID);

        console.log("Fetching data w.r.to custom participantName and EUID and timerange", participantName, " - ", participantEUID, "- From:" , selectedDateRange?.from.toISOString(), " To:", selectedDateRange?.to.toISOString())
      
        setLoading(true);
        setNoData(false);

        const fetchData = async () => {
          setLoading(true);
      
          try {
            const response = await axios.get(
              `${BASE_URL}/participantDetailDataOPT/?participant_name=${participantName}&participant_euid=${participantEUID}&timezone_string=${selectedTimezoneString}&timerange_from=${selectedDateRange?.from?.toISOString()}&timerange_to=${selectedDateRange?.to?.toISOString()}`
            );
        
            if (response.data['statusCode'] === 200) {
              console.log("UNTOUCHED DATA", response.data);
              console.log("THE DATA IS HERE", JSON.parse(response.data['body'])['participant_data']);
              sethotcoldGraph(JSON.parse(response.data['body'])['participant_data']);
              settempmovGraph(JSON.parse(response.data['body'])['tempandmovement_data']);
              setIntriangleGraph(JSON.parse(response.data['body'])['intrianglerhythm_data'])
              // setPlotData(JSON.parse(response.data['body'])['participant_data']);
              // setStudyName(JSON.parse(response.data['body'])['study_name']);
              // setNoDataParticipants(JSON.parse(response.data['body'])['participant_with_no_data'])
              console.log("THE PLOT DATA IS HERE");
              console.log(JSON.parse(response.data['body']));
            } else if(response.data['statusCode'] === 204){
              // setStudyName(storeStudy.study.StudyName);
              setNoData(true);
              console.log("No Data")
              console.log("No DATA", response.data);
            } else {
              console.log("UNTOUCHED ERROR", response);
              throw new Error('Failed to fetch data');
            }
          } catch (err: unknown) {
            if (axios.isAxiosError(err)) {
              // The error is an Axios error
              if (err.response) {
                // Server responded with a status other than 2xx
                console.error('Error response:', err.response);
                console.error('Status code:', err.response.status);
                console.error('Error data:', err.response.data);
              } else if (err.request) {
                // Request was made but no response was received
                console.error('No response received:', err.request);
              } else {
                // Something else happened during setup
                console.error('Error', err.message);
              }
            } else {
              // The error is not an Axios error
              console.error('Unknown error:', err);
            }
          } finally {
            setLoading(false);
            // setSharedState(false);
            // setRefreshDate(getCurrentDate());
            // setRefereshing(false);
          }
        };
        
        fetchData();

      }

    }, [participantName, participantEUID, selectedDateRange]);

    const handleTimeRangeSelection = (data: DateRange, timezoneString: string) => {
      console.log('DateTime Range received from CustomTimeSelectionButtonBar in ParticipantDetailsModal:', data); // Log for debugging
      // -- Now after you get the correct time here -- manage it effectively to call the api to fetch the dashboard or relevant data.
      setSelectedDateRange(data); 
      setSelectedTimezoneString(timezoneString);
    };

    // Function to calculate relative datetime
    function getRelativeDate(date: Date, adjustment: { days?: number; months?: number; years?: number }): Date {
      const newDate = new Date(date); // Create a copy of the date object

      if (adjustment.days) {
      newDate.setUTCDate(newDate.getUTCDate() + adjustment.days);
      }
      if (adjustment.months) {
      newDate.setUTCMonth(newDate.getUTCMonth() + adjustment.months);
      }
      if (adjustment.years) {
      newDate.setUTCFullYear(newDate.getUTCFullYear() + adjustment.years);
      }

      return newDate;
    
    }

    useEffect(() => {

      const now = new Date();

      const currentDate = new Date(Date.UTC(
          now.getUTCFullYear(),
          now.getUTCMonth(),
          now.getUTCDate(),
          now.getUTCHours(),
          now.getUTCMinutes(),
          now.getUTCSeconds(),
          now.getUTCMilliseconds()
      ));

      if(currentTimeline == "Today"){
        
        setSelectedDateRange({
          from: getRelativeDate(currentDate, { days: -1 }),
          to: currentDate,
        })

      }else if(currentTimeline == "3 Days"){
    
        setSelectedDateRange({
          from: getRelativeDate(currentDate, { days: -3 }),
          to: currentDate,
        })
  
      }else if(currentTimeline == "1 Week"){

        setSelectedDateRange({
          from: getRelativeDate(currentDate, { days: -7 }),
          to: currentDate,
        })

      }else if(currentTimeline == "1 Month"){

        setSelectedDateRange({
          from: getRelativeDate(currentDate, { months: -1 }),
          to: currentDate,
        })

      }

    }, [currentTimeline])

    // ----------------------------------------------------------------------------------------------------------------
    // The below is the code for handling replots of the graph (When the user selects a particular portion of the plot)

    const [xAxisRange, setXAxisRange] = useState<[number, number] | null>(null);

    const handleRelayout = useCallback((eventData : any) => {

      if (eventData["xaxis.range[0]"] && eventData["xaxis.range[1]"]) {

        const newXAxisRange : [number, number] = [eventData["xaxis.range[0]"], eventData["xaxis.range[1]"]];
        setXAxisRange(newXAxisRange);

      } else if (eventData["xaxis.range"]) {
        
        const newXAxisRange : [number, number] = [eventData["xaxis.range"][0], eventData["xaxis.range"][1]];
        setXAxisRange(newXAxisRange);

      }

    }, [])

    // ----------------------------------------------------------------------------------------------------------------

    const [selectedDateRangeViewer, setSelectedDateRangeViewer] = useState<DateRange | undefined>({
      from: undefined,
      to: undefined,
    });

    // ----------------------------------------------------------------------------------------------------------------

    useEffect(() => {
      
      console.log("xAxisTimeRange")
      console.log(typeof xAxisRange);

      if(xAxisRange){
        
        const fromDate = new Date(xAxisRange[0]);
        const toDate = new Date(xAxisRange[1]);

        setSelectedDateRangeViewer({from : fromDate, to : toDate})

      }

    }, [xAxisRange])



    useEffect(() => {

      console.log("Selected Date Range")
      console.log(typeof selectedDateRange?.from)

      setSelectedDateRangeViewer({from : selectedDateRange?.from, to : selectedDateRange?.to})

    }, [selectedDateRange])


    // useEffect(() => {
    //   console.log(xAxisRange);
    // }, [xAxisRange])


    return (
        <div className='dashboard-participant-details-modal' ref={modalRef}>
            <div className="modal-header">
                <div className="main-heading">
                    {isMobile ? (
                      <></>
                    ) : (
                      <>
                          <div style={{height  : '40px'}}></div>
                      </>
                    )}
                    <div><span className="title label-medium">Participant</span></div>
                    <div><span className="title title-large">{participantName}</span></div>
                </div>
                <div className="main-heading-right">
                    <MasterButton
                        options={{
                            layoutType: ButtonLayoutType.Icon,
                            size: ButtonSize.Medium,
                            variation: ButtonVariation.Clean,
                            label: "",
                            icon:Close,
                            className: "close-button",
                        }}
                        onClick={onCloseClicked}
                    />

                    {isMobile ? (
                        <></>
                    ) : (
                        <>
                            <div style={{height : '10px'}}></div>
                            <div><span className="title label-medium">Organization {organizationName}</span></div>
                            <div><span className="title label-medium">Study {studyName}</span></div>
                        </>
                    )}


                    
                </div>
            </div>

            <div className='buttons-bar'>
                {isMobile ? (
                  <></>
                ) : (
                  <>
                    <div className='inner-nav-bar'>
                        <TabmenuBasic
                            isDisabled={false}
                            isLoading={false}
                            items={[{title: "Health Data"},{title: "Sensors"},]}
                            onTabSelected={(index) => {
                            if (index !== selectedTabIndex) {
                                setSelectedTabIndex(index);
                            }
                            }}
                        ></TabmenuBasic>
                    </div>
                  </>
                )}

                <div className={`timeselection-bar ${isMobile ? 'mobile-modification' : ''}`}>
                      
                    {selectedTabIndex == 0 ? (
                      // <ButtonGroup buttons={buttons} groupClassName="custom-button-group" />
                      // Change class in the below and the configuration
                      // after that focus on alignment off all
                      <div className={`time-selection-bar-info`}>
                        <CustomTimeSelectionButtonBar onSelect={handleTimeRangeSelection} modalSize={{ height: `calc(100vh - 400px)` }} parentID="dashboard-details-modal-time-selector-button-bar" showCustom={!isMobile} isMobile={isMobile} defaultTime={isMobile ? "1 Week" : "1 Week"} />
                        
                        {isMobile ? (
                          <></>
                        ) : (
                          <>
                              <div className="time-range-indicator">
                                <div className={`body-small time-range-block`}>
                                  <span className="time-range">{`${formatDateRange(selectedDateRangeViewer?.from)} - ${formatDateRange(selectedDateRangeViewer?.to)}`}</span>
                                  <span className="time-zone-text">{`${selectedTimezoneString} (${getUTCOffset(selectedTimezoneString)})`}</span>
                                </div> 
                              </div>
                          </>
                        )}

                      </div>
                      
                    ): (
                      <MasterButton
                        options={{
                            layoutType: ButtonLayoutType.Icon,
                            size: ButtonSize.Medium,
                            variation: ButtonVariation.Outlined,
                            label: "",
                            icon: EditButton,
                        }}
                        onClick={() => {
                            console.log("Info icon clicked");
                        }}
                        disabled={true}
                      />
                    )}  
                    
                </div>
            </div>

            {isMobile ? (
                <></>
            ) : (
                <>
                    <div className="common-ticks-label">

                        {tempmovGraph && !isLoading && tempmovGraph.map((x: any, i: number) => (

                          <Plot
                            data={
                              JSON.parse(x.temp_graph).data.map((trace : Trace) => ({
                                ...trace,
                                opacity: 0, // Make the trace invisible by setting opacity to 0
                              }))
                            } 
                            layout={{
                              width: plotWidth,
                              height: 60,            // Adjust height for the X-axis component
                              xaxis: {
                                ...JSON.parse(x.temp_graph).layout.xaxis,
                                range: xAxisRange || JSON.parse(x.temp_graph).layout.xaxis.range,
                                // tickvals: JSON.parse(plotData[0].chart_data).layout.xaxis.tickvals,  // Use the tick values from one of the plots
                                // ticktext: JSON.parse(plotData[0].chart_data).layout.xaxis.ticktext,  // Use the tick labels from one of the plots
                                // showticklabels: true,  // Show the tick labels for the common X-axis
                                ticks: "outside",      // Customize the tick style
                                tickformat: "%m/%d/%Y \n %H:%M", // "%d/%m/%Y \n %H:%M",
                                tickmode: 'auto',
                                dragmode: false,
                                hovermode: false,
                                side: 'top',
                                tickfont: {
                                  family: 'Lexend',
                                  size: 12,                     // Customize font size
                                  color: '#60598f',                // Customize font color
                                },
                              },
                              yaxis: { visible: false },  // Hide Y-axis
                              margin: {
                                t: 85, b: 0, l: 45, r: 0,   // Adjust margins to fit the axis
                              },
                              dragmode: "zoom",
                              hovermode: false,
                            }}
                            config={{
                              displayModeBar: false, // Disable the mode bar completely
                              doubleClick: 'reset'
                            }}
                            style={{
                              cursor: 'none',  // Set a static cursor
                            }}
                            onRelayout={handleRelayout}
                            className="custom-top-border"
                          />

                        ))}

                    </div>
                
                </>
            )}

            



            <div className={`participant-detail-content ${isMobile ? 'mobile-modification' : ''}`}>
              {selectedTabIndex == 0? (
                <>
                
                  {/* The participant specific charts will appear here */}
                  {isLoading ? (
                    <div className="loading-center-content">
                      <span className="title title-small">Loading data for Participant {participantName} ...</span>
                    </div>
                  ) : noData ? (

                    <div className="loading-center-content">
                      <span className="title title-small">There is no available data for Participant {participantName} in the selected Time Range.</span>
                    </div>

                  ) : (
                    <>

                      {tempmovGraph && tempmovGraph.map((x: any, i: number) => (
                        
                          <div className="participant-chart-data" key={i+25}>
                            <div className="participant-chart" id={`plot-id-${i+25}`}>

                              <div className={`participant-detail-title ${isMobile ? 'mobile-modification' : ''}`}>
                                <span className="title title-medium">Temperature</span> 
                              </div>

                              <Plot
                                data={JSON.parse(x.temp_graph).data}
                                layout={{
                                  ...JSON.parse(x.temp_graph).layout,
                                  width: plotWidth,         // Modify the width of the plot
                                  height: 200, 
                                  showlegend: false, 
                                  margin: {
                                    t: 0, b: 40, l: 30, r: 0,  // Adjust margins to fit the axis
                                  },
                                  xaxis: {
                                    ...JSON.parse(x.temp_graph).layout.xaxis,
                                    range: xAxisRange || JSON.parse(x.temp_graph).layout.xaxis.range, // Use centralized range or default
                                    // showticklabels: true,  // Show the tick labels for the common X-axis
                                    ticks: "outside",
                                    tickformat: "%m/%d/%Y \n %H:%M", // "%d/%m/%Y \n %H:%M",
                                    tickmode: 'auto',
                                    side: 'bottom',
                                    tickfont: {
                                      family: 'Lexend',
                                      size: 12,                     // Customize font size
                                      color: '#60598f',                // Customize font color
                                    },
                                  },
                                  yaxis: {
                                    ...JSON.parse(x.temp_graph).layout.yaxis, // Spread existing Y-axis configuration
                                    // showticklabels: false, // Show tick labels for the Y-axis
                                    title: { text: "" },
                                    ticks: "outside",
                                    tickmode: 'auto',
                                    side: 'left',
                                    position: -0.05,
                                    // ticklabelposition: "outside left", // Move labels further left
                                    tickfont: {
                                      family: 'Lexend',
                                      size: 12,                     // Customize font size
                                      color: '#c94912',                // Customize font color
                                    },
                                    automargin: true, // Ensure space for labels dynamically
                                  },

                                  yaxis2: {
                                    ...JSON.parse(x.temp_graph).layout.yaxis2, // Spread existing Y-axis2 configuration
                                    title: { text: "" },
                                    // showticklabels: false, // Hide tick labels for secondary Y-axis (y2)
                                    // ticks: "inside",
                                    tickmode: "auto",
                                    side: 'right',
                                    tickfont: {
                                      family: 'Lexend',
                                      size: 12,                     // Customize font size
                                      color: '#646175',                // Customize font color
                                    },
                                    overlaying: 'y', // Overlay y2 on y1
                                    position: 0.01,   // Shift y2-axis slightly to the right
                                    automargin: true, // Ensure space for labels dynamically
                                  },
                                  
                                  dragmode: isMobile ? false : "zoom", // 'none' will enable the drag mode (disable entirely - 'false') - this is what we want to use inside the participant detail page
                                  // selectdirection: 'h',
                                  // dragmode: false,
                                }}
                                key={i} // Always include a key when rendering lists in React
                                config={{
                                  displayModeBar: false, // Disable the mode bar completely
                                  doubleClick: 'reset',
                                }}
                                onRelayout={handleRelayout}
                                className="no-cursor custom-border-allsides"
                              />

                              <div className="participant-chart-legend">
                                <div>
                                    <div className="legend-label-box" style={{backgroundColor:'#c94912'}}></div>
                                    <span className="title label-medium">Skin Temp</span>
                                </div>
                                <div>
                                    <div className="legend-label-box" style={{backgroundColor: '#646175'}}></div>
                                    <span className="title label-medium">Heat</span>
                                </div>
                                
                              </div>

                            </div>
                          </div>  
                        
                      ))}

                      {intriangleGraph && intriangleGraph.map((x: any, i: number) => (
                        
                          <div className="participant-chart-data" key={i}>
                            

                            <div className="participant-chart" id={`plot-id-${i+15}`}>

                              <div className={`participant-detail-title ${isMobile ? 'mobile-modification' : ''}`}>
                                <span className="title title-medium">In Triangle Rhythm</span> 
                              </div>

                              <Plot
                                data={JSON.parse(x.in_triangle_chart_data).data}
                                layout={{...JSON.parse(x.in_triangle_chart_data).layout,
                                  width: plotWidth,         // Modify the width of the plot
                                  height: 200, 
                                  showlegend: false, 
                                  margin: {
                                    t: 0, b: 40, l: 47, r: 0,  // Adjust margins to fit the axis
                                  },
                                  xaxis: {
                                    ...JSON.parse(x.in_triangle_chart_data).layout.xaxis,
                                    range: xAxisRange || JSON.parse(x.in_triangle_chart_data).layout.xaxis.range,
                                    // showticklabels: false,  // Show the tick labels for the common X-axis
                                    ticks: "outside",
                                    tickformat: "%m/%d/%Y \n %H:%M", // "%d/%m/%Y \n %H:%M",
                                    tickmode: 'auto',
                                    side: 'bottom',
                                    tickfont: {
                                      family: 'Lexend',
                                      size: 12,                     // Customize font size
                                      color: '#60598f',                // Customize font color
                                    },
                                  },
                                  yaxis: {
                                    ...JSON.parse(x.in_triangle_chart_data).layout.yaxis, // Spread existing Y-axis configuration
                                    showticklabels: true, // Show tick labels for the Y-axis
                                    tickfont: {
                                      family: 'Lexend',
                                      size: 12,                     // Customize font size
                                      color: '#60598f',                // Customize font color
                                    },
                                  },
                                  dragmode: isMobile ? false : "zoom", // 'none' will enable the drag mode - this is what we want to use inside the participant detail page
                                  
                                }}
                                key={i} // Always include a key when rendering lists in React
                                config={{
                                  displayModeBar: false, // Disable the mode bar completely
                                  doubleClick: 'reset',
                                }}
                                onRelayout={handleRelayout}
                                className="no-cursor custom-border-allsides"
                              />

                              <div className="participant-chart-legend">
                                <div>
                                    <div className="legend-label-box" style={{backgroundColor:'#44b0d4'}}></div>
                                    <span className="title label-medium">Hinge</span>
                                </div>
                                
                                <div>
                                    <div className="legend-label-box" style={{backgroundColor:'#15705e'}}></div>
                                    <span className="title label-medium">Cozy</span>
                                </div>
                                
                                <div>
                                    <div className="legend-label-box" style={{backgroundColor:'#ffc42e'}}></div>
                                    <span className="title label-medium">Exposed</span>
                                </div>
                                
                                <div>
                                    <div className="legend-label-box" style={{backgroundColor:'#ff5f1a'}}></div>
                                    <span className="title label-medium">Notch</span>
                                </div>
                                
                                <div>
                                    <div className="legend-label-box" style={{backgroundColor:'#E2E1EB'}}></div>
                                    <span className="title label-medium">Offwrist</span>
                                </div>
                                
                              </div>

                            </div>
                          </div>

                        
                      ))} 

                      {hotcoldGraph && hotcoldGraph.map((x: any, i: number) => (
                        
                          <div className="participant-chart-data" key={i}>
                            <div className="participant-chart" id={`plot-id-${i}`}>

                              <div className={`participant-detail-title ${isMobile ? 'mobile-modification' : ''}`}>
                                <span className="title title-medium">Anomalies</span> 
                              </div>

                              <Plot
                                data={JSON.parse(x.chart_data).data}
                                layout={{...JSON.parse(x.chart_data).layout,
                                  width: plotWidth,         // Modify the width of the plot
                                  height: 200, 
                                  showlegend: false, 
                                  margin: {
                                    t: 0, b: 40, l: 47, r: 0,  // Adjust margins to fit the axis
                                  },
                                  xaxis: {
                                    ...JSON.parse(x.chart_data).layout.xaxis,
                                    range: xAxisRange || JSON.parse(x.chart_data).layout.xaxis.range,
                                    // showticklabels: false,  // Show the tick labels for the common X-axis
                                    ticks: "outside",
                                    tickformat: "%m/%d/%Y \n %H:%M", // "%d/%m/%Y \n %H:%M",
                                    tickmode: 'auto',
                                    side: 'bottom',
                                    tickfont: {
                                      family: 'Lexend',
                                      size: 12,                     // Customize font size
                                      color: '#60598f',                // Customize font color
                                    },
                                  },
                                  yaxis: {
                                    ...JSON.parse(x.chart_data).layout.yaxis, // Spread existing Y-axis configuration
                                    showticklabels: true, // Show tick labels for the Y-axis
                                    tickfont: {
                                      family: 'Lexend',
                                      size: 12,                     // Customize font size
                                      color: '#60598f',                // Customize font color
                                    },
                                  },
                                  dragmode: isMobile ? false : "zoom", // 'none' will enable the drag mode - this is what we want to use inside the participant detail page
                                  
                                }}
                                key={i} // Always include a key when rendering lists in React
                                config={{
                                  displayModeBar: false, // Disable the mode bar completely
                                  doubleClick: 'reset',
                                }}
                                onRelayout={handleRelayout}
                                className="no-cursor custom-border-allsides"
                              />

                              <div className="participant-chart-legend">
                                <div>
                                    <div className="legend-label-box" style={{backgroundColor:'#FFC42E'}}></div>
                                    <span className="title label-medium">Pre-fever</span>
                                </div>
                                <div>
                                    <div className="legend-label-box" style={{backgroundColor:'#E0004b'}}></div>
                                    <span className="title label-medium">Fever</span>
                                </div>
                                <div>
                                    <div className="legend-label-box" style={{backgroundColor:'#80A8BD'}}></div>
                                    <span className="title label-medium">Preshock</span>
                                </div>
                                <div>
                                    <div className="legend-label-box" style={{backgroundColor:'#00527A'}}></div>
                                    <span className="title label-medium">Shock</span>
                                </div>
                                <div>
                                    <div className="legend-label-box" style={{backgroundColor:'#E2E1EB'}}></div>
                                    <span className="title label-medium">Offwrist</span>
                                </div>
                                
                              </div>

                            </div>
                          </div>

                        
                      ))}

                      {tempmovGraph && tempmovGraph.map((x: any, i: number) => (
                        
                          <div className="participant-chart-data" key={i+5}>
                            <div className="participant-chart" id={`plot-id-${i+5}`}>

                              <div className={`participant-detail-title ${isMobile ? 'mobile-modification' : ''}`}>
                                <span className="title title-medium">Movement</span> 
                              </div>

                              <Plot
                                data={JSON.parse(x.movement_graph).data}
                                layout={{...JSON.parse(x.movement_graph).layout,
                                  width: plotWidth,         // Modify the width of the plot
                                  height: 200, 
                                  showlegend: false, 
                                  margin: {
                                    t: 0, b: 40, l: 47, r: 0,  // Adjust margins to fit the axis
                                  },
                                  xaxis: {
                                    ...JSON.parse(x.movement_graph).layout.xaxis,
                                    range: xAxisRange || JSON.parse(x.movement_graph).layout.xaxis.range,
                                    // showticklabels: false,  // Show the tick labels for the common X-axis
                                    tickformat: "%m/%d/%Y \n %H:%M", // "%d/%m/%Y \n %H:%M",
                                    tickmode: 'auto',
                                    tickfont: {
                                      family: 'Lexend',
                                      size: 12,                     // Customize font size
                                      color: '#60598f',                // Customize font color
                                    },
                                  },
                                  yaxis: {
                                    ...JSON.parse(x.movement_graph).layout.yaxis, // Spread existing Y-axis configuration
                                    showticklabels: true, // Show tick labels for the Y-axis
                                    tickfont: {
                                      family: 'Lexend',
                                      size: 12,                     // Customize font size
                                      color: '#60598f',                // Customize font color
                                    },
                                  },  
                                  dragmode: isMobile ? false : "zoom", // 'none' will enable the drag mode - this is what we want to use inside the participant detail page
                                  
                                }}
                                key={i} // Always include a key when rendering lists in React
                                config={{
                                  displayModeBar: false, // Disable the mode bar completely
                                  doubleClick: 'reset',
                                }}
                                onRelayout={handleRelayout}
                                className="no-cursor custom-border-allsides"
                              />

                              <div className="participant-chart-legend">
                                <div>
                                    <div className="legend-label-box" style={{backgroundColor:'#00803C'}}></div>
                                    <span className="title label-medium">G-Force</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        
                      ))}
                      
                      <div style={{ width:"100%", minHeight:"100px", paddingBottom:"25px"}}></div>

                    </>
                  )}

                
                </>
              ) : (
                <>

                  {/* The Sensors Details will appear here */}
                
                </>
              )}
            </div>
        </div>
    );
};

export default DashboardParticipantDetailsModal;
